import { Box, Typography } from '@mui/material'

import { formatNumber } from '../utils'

type CountBadgeProps = {
  count: number
  singularLabel: string
  pluralLabel: string
}

const CountBadge = ({ count, singularLabel, pluralLabel }: CountBadgeProps) => (
  <Box
    sx={{
      height: 32,
      borderRadius: '6px',
      backgroundColor: '#F7F7F7',
      px: 2,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      alignSelf: { xs: 'flex-end', md: 'center' },
      flexShrink: 0
    }}
  >
    <Box
      component="i"
      className="fa-light fa-envelope"
      sx={{ color: '#656565', fontSize: 12 }}
    />
    <Typography sx={{ color: '#464646', fontSize: 12, fontWeight: 500 }}>
      {formatNumber(count)} {count === 1 ? singularLabel : pluralLabel}
    </Typography>
  </Box>
)

export default CountBadge
